module.exports = __webpack_public_path__ + "static/media/icon-no.654fdbdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-no.svg
// module id = 1470
// module chunks = 0